

/*logging*/

$('.terminal .log').click(function(e){

	var next = $(this).attr('next');
	var data = new FormData();
	data.append('name',$(this).attr('name'));
	data.append('value',$(this).attr('value'));

	$.ajax({
		type: 'POST',
		url: './files/handler/handle.terminal.log.php',
		data: data,
		async: true,
		cache: false,
		contentType: false,
		processData: false,
		success: function(reply){

			if(reply == 'ok'){
				$('.charts').slick('slickGoTo',next-1,false);
			}

		}

	});

	if(next == 1){
		$('#terminalform')[0].reset();
	}

});




/*signup*/

$('.terminal form.form').submit(function(e){

	e.preventDefault();

	/*prepare*/
	const trigger = $(this).find('button');
	trigger.html(trigger.attr('sending'));

	/*create form data*/
	var data = new FormData($(this)[0]);

	/*add metas*/
	data.append('group',trigger.attr('group'));
	data.append('mask',trigger.attr('mask'));

	/*post*/
	$.ajax({
		type: 'POST',
		url: './files/handler/handle.terminal.signup.php',
		data: data,
		async: true,
		cache: false,
		contentType: false,
		processData: false,
		success: function(reply){

			/*feedback*/
			if(
				reply == 'ok' ||
				reply == 'duplicate'
			){
				trigger.html(trigger.attr('success'));
				setTimeout(function(){
					trigger.html(trigger.attr('default'));
					$('#terminalform')[0].reset();
					setTimeout(function(){
						$('.charts').slick('slickGoTo',0,false);
					},2000);
				},5000);
			}else{
				trigger.html(trigger.attr('error'));
				console.log(reply);
			}

		}

	});

});


